import { create } from 'zustand'

export type ToastTone = 'neutral' | 'danger'
type ToastState = {
  message: string | null
  tone: ToastTone
  show: (message: string, tone?: ToastTone) => void
  hide: () => void
}

let timer: ReturnType<typeof setTimeout> | null = null

export const useToast = create<ToastState>((set) => ({
  message: null,
  tone: 'neutral',
  show: (message, tone = 'neutral') => {
    if (timer) clearTimeout(timer)
    set({ message, tone })
    timer = setTimeout(() => set({ message: null }), 3200)
  },
  hide: () => {
    if (timer) clearTimeout(timer)
    set({ message: null })
  },
}))

/** One toast host, mounted by the shell. Announced politely, never stealing focus. */
export function Toast() {
  const { message, tone } = useToast()
  return (
    <output aria-live="polite" className="visually-hidden">
      {message ?? ''}
      {message ? (
        <div className={['toast', tone === 'danger' ? 'toast--danger' : ''].join(' ')}>
          {message}
        </div>
      ) : null}
    </output>
  )
}
